import { includes, toUpper } from 'lodash';

export default function isDomestic(country) {
  return includes(['US', 'VI'], toUpper(country));
}
